import type { WithChildren } from '@/_metronic/helpers';
import { createContext, type FC, useCallback, useContext, useMemo } from 'react';

type LayoutSplashScreenContextType = {
  showSplashScreen: () => void;
  hideSplashScreen: () => void;
};

const LayoutSplashScreenContext = createContext<LayoutSplashScreenContextType>({
  showSplashScreen: () => {},
  hideSplashScreen: () => {},
});

const LayoutSplashScreenProvider: FC<WithChildren> = ({ children }) => {
  const showSplashScreen = useCallback(() => {
    document.body.classList.add('page-loading');
  }, []);

  const hideSplashScreen = useCallback(() => {
    document.body.classList.remove('page-loading');
  }, []);

  const contextValue: LayoutSplashScreenContextType = useMemo(
    () => ({
      showSplashScreen,
      hideSplashScreen,
    }),
    [showSplashScreen, hideSplashScreen],
  );

  return <LayoutSplashScreenContext.Provider value={contextValue}>{children}</LayoutSplashScreenContext.Provider>;
};

export const useLayoutSplashScreen = () => {
  const context = useContext(LayoutSplashScreenContext);
  if (!context) {
    throw new Error('useLayoutSplashScreen must be used within a LayoutSplashScreenProvider');
  }
  return context;
};

export { LayoutSplashScreenProvider };
